import Vue from "vue";
import Vuex from "vuex";
import view from "@/store/view";

Vue.use(Vuex);

const oldKey = "castme";
const oldData = localStorage.getItem(oldKey);
if (oldData) {
  localStorage.setItem("app", oldData);
  localStorage.removeItem(oldKey);
}

const store = new Vuex.Store({
  modules: {
    view,
  },
  actions: {
    reset() {
      this.dispatch("view/reset");
    },
  },
});

export default store;
